/**
 * Set cursor to store
 *
 * @param {Object} state
 * @param {integer} value
 * @return {*}
 */
export function setCursor(state, value) {
    return {
        ...state,
        cursor: state.cursor === null ? null : (typeof value === 'object' && value !== null ? (state.cursor + value.add) : value),
    }
}

/**
 * Reset cursor into zero
 *
 * @param {Object} state
 * @return {*}
 */
export function setZeroCursor(state) {
    return {
        ...state,
        cursor: 0,
    }
}

/**
 * Set prototypes full data to store
 *
 * @param {Object} state
 * @param {Object} data
 * @return {*}
 */
export function prototypeSetData(state, data) {
    return {
        ...state,
        ...data,
    }
}

/**
 * Set user total event count
 *
 * @param {Object} state
 * @param {Object} count
 * @return {*}
 */
export function prototypeSetTotalCount(state, count) {
    return {
        ...state,
        totalCount: count,
    }
}

/**
 * Set prototypes full data to store
 *
 * @param {Object} state
 * @param {string} element  - name of data element, ex. sportVenues, which is defined as data param in store
 * @param {Object} data
 * @return {*}
 */
export function prototypeAppendData(state, element, data) {
    return  {
        ...state,
        [element]: [
            ...data?.[element],
        ],
    }
}

/**
 * Set prototypes busy into store
 *
 * @param {Object} state
 * @param {boolean} busy
 * @return {*}
 */
export function prototypeSetBusy(state, busy) {
    return {
        ...state,
        busy: busy,
    }
}

/**
 * Set prototypes markers to store
 *
 * @param {Object} state
 * @param {Object} markers
 * @return {*}
 */
export function prototypeSetMarkers(state, markers) {
    return {
        ...state,
        markers: markers,
    }
}

/**
 * Set prototypes is init load
 *
 * @param {Object} state
 * @param {boolean} initLoad
 * @return {*}
 */
export function prototypeSetInitLoad(state, initLoad) {
    return {
        ...state,
        initLoad: initLoad,
    }
}

/**
 * Set if can load more items
 *
 * @param {Object} state
 * @param {boolean} canLoadMore
 * @return {*}
 */
export function prototypeSetCanLoadMore(state, canLoadMore) {
    return {
        ...state,
        canLoadMore: canLoadMore,
    }
}
